import { GetBankAccountSelectionUrlResponse } from '@/types/api/payment-user/responses/get-bank-account-selection-url.response';
import { authenticatedClient } from '@/utils/shared/axios';

export default {
  getBankAccountSelectionUrl: async (redirectUrl: string): Promise<GetBankAccountSelectionUrlResponse> => {
    const response = await authenticatedClient.get<GetBankAccountSelectionUrlResponse>(
      `/payments/users/selection-url?redirectUrl=${encodeURIComponent(redirectUrl)}`,
    );
    return response.data;
  },

  authenticate: async () => {
    const response = await authenticatedClient.post('/payments/users/auth');
    return response.data;
  },

  getAuthentication: async (authenticationToken: string) => {
    const response = await authenticatedClient.get(`/payments/users/auth?authenticationToken=${authenticationToken}`);
    return response.data;
  },

  get: async () => {
    const response = await authenticatedClient.get(`/payments/users`);
    return response.data;
  },
};
